module.exports = __webpack_public_path__ + "static/media/aiimg.52157482.png";